export const SET_ROOM = 'ROOMLIST/SET_ROOM'
export const SET_ROOMS = 'ROOMLIST/SET_ROOMS'
